/*
 * Copyright 2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

//AWS color palette
export const AWS_COLOR_PALETTE = [
    
    {
        "name": "Berry",
        "hex": "#9e1f63"
    },
    {
        "name": "Aqua - Bright",
        "hex": "#a6e7ce"
    },
    {
        "name": "AWS Orange",
        "hex": "#ff6633"
    },
    {
        "name": "AWS Yellow",
        "hex": "#f3e502"
    },
    {
        "name": "Green Apple",
        "hex": "#18ab4b"
    },
    {
        "name": "Aqua",
        "hex": "#00464f"
    },
    {
        "name": "Sea Blue",
        "hex": "#005276"
    },
    {
        "name": "Paper",
        "hex": "#f1f3f3"
    },
    {
        "name": "Plum - Medium",
        "hex": "#504bab"
    },
    {
        "name": "Plum - Bright",
        "hex": "#7e93ee"
    },

    {
        "name": "Berry - Medium",
        "hex": "#c9208a"
    },
    {
        "name": "Sea Blue - Bright",
        "hex": "#7cd1ea"
    },
    {
        "name": "Berry - Bright",
        "hex": "#ff99ff"
    },

    {
        "name": "Smile",
        "hex": "#ff9900"
    },


    {
        "name": "Green Apple - Medium",
        "hex": "#ade422"
    },
    {
        "name": "Green Apple - Bright",
        "hex": "#e4fdbf"
    },

    {
        "name": "Aqua - Medium",
        "hex": "#36c2b4"
    },
    {
        "name": "Plum",
        "hex": "#262262"
    },

    {
        "name": "Sea Blue - Medium",
        "hex": "#008296"
    },

    {
        "name": "Squid Ink",
        "hex": "#232F3E"
    },
    {
        "name": "Stone",
        "hex": "#d4dada"
    },

];
